import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const assignedCompaniesListSlice = createSlice({
    name: 'ui/assigned-companies-list',
    initialState: {
        ...initialState,
        filters: { ...initialState.filters, matchingPercentage: 'all' },
        pureFilters: { ...initialState.pureFilters, matchingPercentage: 'all' }
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { matchingPercentage: 'all' }
            state.pureFilters = { matchingPercentage: 'all' }
        }
    }
})

export const assignedCompaniesListActions = assignedCompaniesListSlice.actions
export default assignedCompaniesListSlice.reducer
